/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration"
import { CancelToken } from "axios";
import { ISearchField } from "../shared/interfaces";
import { IProtocolsSearchPageResult, ISearchCriteria } from "../shared/interfacesDTO";

const controller = 'Search';

const search = (aooId: number, searchCriteria: ISearchCriteria, cancelToken?: CancelToken): Promise<IProtocolsSearchPageResult> => {
    return axiosInstance.post(`${controller}/${aooId}/Search`, searchCriteria, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getSearchAiFields = (cancelToken?: CancelToken): Promise<ISearchField[]> => {
    return axiosInstance.get(`${controller}/GetSearchAiFields`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

export default {
    search,
    getSearchAiFields
}